import React from 'react';
import { MapPin, Phone, Mail, Linkedin, Instagram, Twitter, Facebook, Youtube } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const headerOffset = 120;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-modern" id="contact">
      <div className="footer-main">
        <div className="footer-container">
          <div className="footer-column footer-brand">
            <div className="footer-logo-wrapper">
              <img 
                src="/gedik-logo.png" 
                alt="Gedik Group" 
                className="footer-logo-modern"
                onClick={scrollToTop}
                style={{ cursor: 'pointer' }}
              />
            </div>
            <p className="footer-description">
              {t('footer.description')}
            </p>
            <div className="footer-social-links">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon-modern" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
              <a href="https://www.instagram.com/gedikgroup" target="_blank" rel="noopener noreferrer" className="social-icon-modern" aria-label="Instagram">
                <Instagram size={20} />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon-modern" aria-label="Twitter">
                <Twitter size={20} />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon-modern" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="social-icon-modern" aria-label="YouTube">
                <Youtube size={20} />
              </a>
            </div>
          </div>

          <div className="footer-column" id="about">
            <h3 className="footer-column-title">{t('footer.servicesTitle')}</h3>
            <ul className="footer-links">
              <li><button onClick={() => scrollToSection('services')} className="footer-link">{t('footer.corporateProjects')}</button></li>
              <li><button onClick={() => scrollToSection('services')} className="footer-link">{t('footer.housingDev')}</button></li>
              <li><button onClick={() => scrollToSection('services')} className="footer-link">{t('footer.infrastructure')}</button></li>
              <li><button onClick={() => scrollToSection('services')} className="footer-link">{t('footer.villaProjects')}</button></li>
              <li><button onClick={() => scrollToSection('services')} className="footer-link">{t('footer.commercial')}</button></li>
            </ul>
          </div>

          <div className="footer-column">
            <h3 className="footer-column-title">{t('footer.corporateTitle')}</h3>
            <ul className="footer-links">
              <li><button onClick={() => scrollToSection('about')} className="footer-link">{t('footer.about')}</button></li>
              <li><button onClick={() => scrollToSection('projects')} className="footer-link">{t('footer.ourProjects')}</button></li>
              <li><button onClick={() => scrollToSection('projects')} className="footer-link">{t('footer.references')}</button></li>
              <li><a href="#" className="footer-link">{t('footer.career')}</a></li>
              <li><a href="#" className="footer-link">{t('footer.press')}</a></li>
            </ul>
          </div>

          <div className="footer-column footer-contact">
            <h3 className="footer-column-title">{t('footer.contactTitle')}</h3>
            <ul className="footer-contact-list">
              <li className="contact-item">
                <MapPin size={18} />
                <span>İstanbul, Türkiye</span>
              </li>
              <li className="contact-item">
                <Phone size={18} />
                <a href="tel:+905334924678">0533 492 46 78</a>
              </li>
              <li className="contact-item">
                <Mail size={18} />
                <a href="mailto:info@gedikgroup.tr">info@gedikgroup.tr</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <p className="footer-copyright">
            © {currentYear} {t('footer.copyright')}
          </p>
          <div className="footer-legal-links">
            <a href="#" className="footer-legal-link">{t('footer.privacy')}</a>
            <a href="#" className="footer-legal-link">{t('footer.terms')}</a>
            <a href="#" className="footer-legal-link">{t('footer.kvkk')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
